module.exports = __webpack_public_path__ + "static/media/shiftshave-replacement-blade-3.bb0cf4bc.png";